var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.4032 27.6622H9.00493C8.123 27.6622 7.4082 26.9474 7.4082 26.0655C7.4082 25.1836 8.123 24.4688 9.00493 24.4688H30.4027C31.2846 24.4688 31.9994 25.1836 31.9994 26.0655C31.9994 26.9474 31.2851 27.6622 30.4032 27.6622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.4032 17.6407H9.00493C8.123 17.6407 7.4082 16.9259 7.4082 16.044C7.4082 15.1621 8.123 14.4473 9.00493 14.4473H30.4027C31.2846 14.4473 31.9994 15.1621 31.9994 16.044C31.9999 16.9259 31.2851 17.6407 30.4032 17.6407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.4032 7.61728H9.00493C8.123 7.61728 7.4082 6.90248 7.4082 6.02055C7.4082 5.13863 8.123 4.42383 9.00493 4.42383H30.4027C31.2846 4.42383 31.9994 5.13863 31.9994 6.02055C31.9994 6.90248 31.2851 7.61728 30.4032 7.61728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.1444 8.28881C3.32873 8.28881 4.28881 7.32873 4.28881 6.1444C4.28881 4.96008 3.32873 4 2.1444 4C0.960082 4 0 4.96008 0 6.1444C0 7.32873 0.960082 8.28881 2.1444 8.28881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.1444 18.1872C3.32873 18.1872 4.28881 17.2272 4.28881 16.0428C4.28881 14.8585 3.32873 13.8984 2.1444 13.8984C0.960082 13.8984 0 14.8585 0 16.0428C0 17.2272 0.960082 18.1872 2.1444 18.1872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.1444 28.0876C3.32873 28.0876 4.28881 27.1276 4.28881 25.9432C4.28881 24.7589 3.32873 23.7988 2.1444 23.7988C0.960082 23.7988 0 24.7589 0 25.9432C0 27.1276 0.960082 28.0876 2.1444 28.0876Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.175ff78fae0a18c3bbbd8f92c5c0dd47.svg";
export { ForwardRef as ReactComponent };